export default "__VITE_ASSET__b7e67afe__"